/**
 * Thin console wrappers for intentional debug/info logging.
 * Prefer logger over raw console.log so no-console stays enforced elsewhere.
 */
export const logger = {
  log: (...args: unknown[]) => {
    console.log(...args);
  },
  info: (...args: unknown[]) => {
    console.info(...args);
  },
  debug: (...args: unknown[]) => {
    console.debug(...args);
  },
};
